import { ReactElement } from 'react';
import { useLocalization } from '../../ContextProviders/LocalizationContext';

export const FourOhFour = (): ReactElement => {
  const localization = useLocalization();
  return <h1>{localization.strings.error[404]}</h1>;
};
